import { IChildrenProps } from "../interfaces/IChildrenProps";
import KeycloakService from "../services/KeycloakService";

const RenderOnAnonymous = ({ children }: IChildrenProps) => {
    return (!KeycloakService.isLoggedIn()) ? children : null;
};

export default RenderOnAnonymous;